/**
 * Yrityksen tunnus (suunnitelma 7).
 *
 * Logo on asennuksen räätälöintiä: oletuksena Devikone Oy:n tunnus, mutta
 * ADMIN voi vaihtaa sen omansa. Siksi oletus on **koodissa** eikä kannassa
 * — tyhjä kanta tarkoittaa oletusta, ja "palauta oletus" on rivin poisto
 * eikä uuden datan kirjoittamista.
 *
 * Kaksi versiota, ei yhtä: sovelluksessa on tumma teema, ja tummalla
 * taustalla musta tunnus katoaa. Tumma versio on valinnainen — jos sitä ei
 * anneta, käytetään vaaleaa molemmissa.
 */
/** Kumman taustan tunnus, ei kumpi teema on valittuna. */
export const LOGO_VARIANTS = ['vaalea', 'tumma'];
export function isLogoVariant(value) {
    return typeof value === 'string' && LOGO_VARIANTS.includes(value);
}
/**
 * Tunnuksen enimmäiskoko. Tunnus tarjoillaan jokaiselle sivulataukselle ja
 * myös kirjautumissivulle, joten se on pieni tiedosto tai se on väärä
 * tiedosto: 512 kt riittää kaksinkertaisen tarkkuuden PNG:lle moninkertaisesti.
 */
export const LOGO_MAX_BYTES = 512 * 1024;
/**
 * Sallitut tiedostotyypit.
 *
 * SVG on mukana, koska tunnus on juuri se kuva, joka halutaan tarkkana
 * joka näytöllä. Se on myös ainoa näistä, joka voi sisältää skriptin:
 * siksi tarjoilupääte lähettää `Content-Security-Policy: sandbox`in ja
 * `X-Content-Type-Options: nosniff`in (`modules/branding/routes.ts`).
 */
export const LOGO_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
export function isLogoMimeType(value) {
    return typeof value === 'string' && LOGO_MIME_TYPES.includes(value);
}
/** Tiedostopäätteet valitsimeen — `accept`-attribuutti ottaa molempia. */
export const LOGO_FILE_ACCEPT = [...LOGO_MIME_TYPES, '.png', '.jpg', '.jpeg', '.webp', '.svg'].join(',');
/** Yrityksen nimen enimmäispituus. Mahtuu kirjautumiskortin leveyteen. */
export const MAX_BRAND_NAME_LENGTH = 60;
/**
 * Oletusnimi. Tyyppi on tarkoituksella `string` eikä merkkijonoliteraali:
 * `SETTING_DEFAULTS` on `as const`, ja literaalityyppi tekisi asetuksesta
 * sellaisen, jonka ainoa sallittu arvo on oletus.
 */
export const DEFAULT_BRAND_NAME = 'Devikone Oy';
//# sourceMappingURL=branding.js.map